import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-companies',
    templateUrl: './no-companies.component.html',
    styleUrls: ['./no-companies.component.scss'],
    standalone: false
})
export class NoCompaniesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
